<template>
<div>
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white">All Submissions s</div>
            </div>
            <div>
                <img :src="require('../../../assets/tenant_image.png')" alt="" />
            </div>
        </div>
    </lcontainer>

    <lcontainer>
        <div class="flex justify-between">
            <page-header class="py-2 colored">Submissions</page-header>
            <div class="flex m-2">
                <span></span>
                <lms-select v-model="selected" :items="courses" class="input1 m-2 p-2" placeholder="Sort by Course name" />
            </div>
        </div>
        <hr class="m-4 " />
        <SubmissionsTable :headers="headers" :actions="actions" :items="getData" />

        <div class="my-4 py-4 px-2 mx-2" />
    </lcontainer>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import moment from "moment";
export default {
    components: {
        SubmissionCard: () => import("@/components/tenant/submission_card"),
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
        LmsTable: () => import("@/components/admin/admin-table"),
        PageHeader: () => import("@/components/general/pageheader"),
        LmsSelect: () => import("@/components/forms/select"),
        linput: () => import("@/components/general/input"),
        SubmissionsTable: () => import("@/components/tenant/tables/submissions"),
    },
    computed: {
        ...mapGetters(["getTenantCourses", "getUser"]),
        getData() {
            if (!this.submissions) return;
            let submissions = this.submissions;
            if (this.selected) {
                submissions = submissions.filter((submission) => {
                    return submission.course_details.id === this.selected && submission.course_details !== null;
                });
            }
            let sorted = [];
            submissions.forEach((submission) => {
                let obj = {};
                if (submission.grading && submission.grading !== null && submission.course_details !== null) {
                    obj.title = submission.grading.title;
                    obj.course = submission.course_details.title;
                    obj.user = submission.learner.name;
                    obj.type = submission.type;
                    obj.submitted = moment(submission.grading.created_at).format(
                        "Do MMMM YYYY"
                    );
                    obj.status =
                        submission.type === "quiz" ? "Graded" : submission.graded;
                    obj.id = submission.id;
                    obj.score = submission.grade;
                    sorted.push(obj);
                }
            });
            return sorted;
        },
    },
    data() {
        return {
            form: {},
            error: {},
            courses: null,
            search: "",
            selected: "",
            submissions: [],
            sort: [{
                    text: "Name",
                    value: "Name"
                },
                {
                    text: "Email",
                    value: "Email"
                },
            ],
            filter: [{
                    text: "Tenants assigned to me",
                    value: "Tenants assigned to me"
                },
                {
                    text: "All Tenants",
                    value: "All Tenants"
                },
            ],
            actions: [{
                type: "edit",
                key: ["Description"],
                func: this.updatePayment,
                icon: "edit",
            }, ],
            headers: [{
                    key: "course",
                    width: "15%",
                    sortable: true
                },
                {
                    key: "title",
                    width: "15%",
                    sortable: true
                },
                {
                    key: "user",
                    width: "15%",
                    sortable: true
                },
                {
                    key: "type",
                    width: "10%",
                    sortable: true,
                    shorten: true,
                    restrictToLen: 50,
                },
                {
                    key: "submitted",
                    width: "15%",
                    sortable: true,
                    defaultSortBy: true,
                    defaultOrder: "DESC",
                },
                {
                    key: "status",
                    width: "10%",
                    sortable: true,
                    defaultSortBy: true,
                    defaultOrder: "DESC",
                },
                {
                    key: "score",
                    width: "10%",
                    sortable: true,
                    defaultSortBy: true,
                    defaultOrder: "DESC",
                },
                {
                    type: "actions",
                    key: "Actions",
                    width: "15%"
                },
            ],
        };
    },
    methods: {
        ...mapActions(["tenantFetchTasks", "fetchTenantCourses"]),
        ...mapMutations(["updateLoader"]),
    },

    async mounted() {
        this.updateLoader(true);
        this.submissions = await this.tenantFetchTasks();
        await this.fetchTenantCourses({
            user: this.getUser
        });
        let data = [];
        this.getTenantCourses.forEach((course) => {
            let obj = {};
            if(course !== null){
                obj.text = course.title;
                obj.value = course.id;
                data.push(obj);
            }

        });
        this.courses = data;
        this.updateLoader(false);
    },
};
</script>

<style lang="scss" scoped>
.colored {
    color: color(lms-tenant);
}
</style>
